import { Gatilho } from "./gatilho.model";
import { GatilhoDiasProxVencimento } from "./gatilhos-impl/gatilho-dias-prox-vencimento.model";
import { GatilhoQuantMinimaEstoque } from "./gatilhos-impl/gatilho-quant-minima-estoque.model";
export enum TipoGatilho {

    // PRODUTO
    DIAS_PROX_VENCIMENTO = 'DIAS_PROX_VENCIMENTO',
    QUANT_MINIMA_ESTOQUE = 'QUANT_MINIMA_ESTOQUE',
    QUANT_MINIMA_INVENTARIO =  'QUANT_MINIMA_INVENTARIO'

    /**
     * Sempre que adicionar um novo tipo de gatilho
     * implementar o GatilhoFactory e criar a classe concreta do mesmo.
     * */

}
